import React from 'react';

class LoadingSpinner extends React.Component {

    render() {
        return (<div className="blank">
            <div className="loaderBar"></div>
            <h2 className="loadingBarText">{(this.props.loadingMessage) ? this.props.loadingMessage : "Loading..."}</h2>

        </div>)

    }

}

export default LoadingSpinner